import React from 'react';
import { Box, Chip, Avatar } from '@mui/material';
import { FunctionCall } from 'types/Chats/ChatMessage';

export type PluginsResultsPillProps = {
  functionCalls: FunctionCall[];
};

const PluginsResultsPill: React.FC<PluginsResultsPillProps> = ({ functionCalls }) => {
  if (!functionCalls || functionCalls.length === 0) {
    return null;
  }

  const renderStatusIndicator = (functionCall: FunctionCall) => {
    const { eventStatusTypeIconURL, eventStatusTypeName } = functionCall;
    
    // Only show indicator if we have a valid status icon URL
    if (!eventStatusTypeIconURL || eventStatusTypeIconURL.trim() === '') {
      return null;
    }

    return (
      <Box
        sx={{
          position: 'absolute',
          bottom: -2,
          right: -2,
          backgroundColor: 'white',
          borderRadius: '50%',
          width: 12,
          height: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={eventStatusTypeIconURL}
          alt={eventStatusTypeName || 'status'}
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
          }}
        />
      </Box>
    );
  };

  const renderFunctionIcon = (functionCall: FunctionCall, index: number) => (
    <Box
      key={functionCall.callId}
      sx={{
        position: 'relative',
        marginLeft: index > 0 ? '-4px' : 0,
        zIndex: functionCalls.length - index,
      }}
    >
      <Avatar
        sx={{
          width: 20,
          height: 20,
          backgroundColor: 'white',
        }}
        src={functionCall.iconURL || undefined}
      >
        {/* Fallback for missing icon */}
        <Box
          sx={{
            width: 12,
            height: 12,
            backgroundColor: 'var(--color-primary)',
            borderRadius: '2px',
          }}
        />
      </Avatar>
      {renderStatusIndicator(functionCall)}
    </Box>
  );

  return (
    <Chip
      label={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {functionCalls.map((functionCall, index) =>
              renderFunctionIcon(functionCall, index)
            )}
          </Box>
          <Box
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: 'var(--color-text-secondary, rgba(0, 0, 0, 0.6))',
            }}
          >
            Plugins
          </Box>
        </Box>
      }
      size="small"
      sx={{
        backgroundColor: 'var(--color-grey-50)',
        borderRadius: '16px',
        height: '24px',
        marginLeft: '0px',
        '& .MuiChip-label': {
          padding: '0 8px',
        },
      }}
    />
  );
};

export default PluginsResultsPill; 